import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, AlertCircle } from 'lucide-react';
import { useReports } from '../hooks/useReports';
import ReportDetail from './ReportDetail';

/**
 * Route adapter for /analysis/:reportId. Pulls the recent-reports list
 * (cached after first fetch) and finds the matching report. Deep-link
 * works because we always fetch the list -- no per-id backend endpoint
 * needed.
 *
 * If the id isn't in the list (older than the 30-day window, or unknown),
 * we render a not-found state with a back link.
 */
const ReportDetailRoute = () => {
  const { reportId } = useParams();
  const navigate = useNavigate();
  const { reports, loading, error } = useReports(30);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error">
        <AlertCircle size={24} />
        <p>{error}</p>
      </div>
    );
  }

  const report = reports.find((r) => r.id === reportId);

  if (!report) {
    return (
      <div>
        <button
          className="btn btn-secondary"
          onClick={() => navigate('/analysis')}
          style={{ display: 'inline-flex', alignItems: 'center', gap: '0.375rem', marginBottom: '1rem' }}
        >
          <ArrowLeft size={16} /> Back to list
        </button>
        <div className="empty-state">
          <AlertCircle size={48} />
          <p>Report not found.</p>
          <p style={{ fontSize: '0.875rem' }}>
            This may be older than the 30-day window, or the link may be stale.
          </p>
        </div>
      </div>
    );
  }

  return (
    <ReportDetail
      report={report}
      onBack={() => navigate('/analysis')}
    />
  );
};

export default ReportDetailRoute;
